import { createPortal } from 'react-dom';

const Modal = ({ children, isOpen, overflowType = 'scroll' }) => {
  if (!isOpen) return null;

  const overflowClass = overflowType === 'scroll' ? 'overflow-scroll' : 'overflow-visible';

  return createPortal(
    <div className='fixed inset-0 backdrop-blur-lg flex items-center justify-center pb-4 pt-[46px] md:pt-0 px-4 z-40 w-full'>
      <div className={`max-h-[80vh] md:max-h-[90vh] w-full md:w-auto md:p-3 ${overflowClass}`}>
        {children}
      </div>
    </div>,
    document.getElementById('portal')
  )
}

export default Modal;
